import { InfoIcon } from '@chakra-ui/icons'
import { Flex, Stack, Text } from '@chakra-ui/react'
import { BoxHeader, ContactButtons, FloatingContainer } from '@hb/react-web'
import { getAdditionalPlansRequested, PopulatedAssessment, PopulatedUser } from '@hb/shared'
import React, { useMemo } from 'react'
import { SignOnStatus } from './SignOnStatus'

export const SignOnPanel: React.FC<{
  assessment: PopulatedAssessment | null
  user: PopulatedUser | null
}> = ({ assessment, user }) => {
  const additionalPlansRequested = useMemo(() => getAdditionalPlansRequested(user), [user])

  // const buttonText = useMemo(() => {
  //   if (!signedOnDate) return 'Complete Sign-on Process'
  //   if (coverageConfirmRequired) return 'Confirm Coverage'
  //   return 'Confirm Plans'
  // }, [signedOnDate, coverageConfirmRequired])

  return (
    <FloatingContainer alignItems="flex-start">
      <Stack spacing={2} w="100%">
        <BoxHeader color="gray.600" _dark={{ color: 'gray.200' }}>
          How would you like to proceed?
        </BoxHeader>
        {assessment?.skippedQuestionnaire ? (
          <Text px={2} fontSize="lg" color="gray.600" _dark={{ color: 'gray.200' }}>
            You've been signed on by one of our administrators! We just need some info before we
            officially get started.
          </Text>
        ) : null}
        {additionalPlansRequested ? (
          <Flex pb={2} align="center" gap={2}>
            <InfoIcon opacity={0.6} />
            <Text lineHeight={1.2} color="gray.600">
              We need some additional information about your coverage.
            </Text>
          </Flex>
        ) : null}
        <SignOnStatus />
        <ContactButtons id="FormsView" mr="auto" width="100%" />
      </Stack>
    </FloatingContainer>
  )
}
